import { AskTigerSparkle } from "./AskTigerSparkle";
import { askTigerLogoStyles as s } from "./AskTigerLogo.styles";
import type { AskTigerLogoProps } from "./AskTigerLogo.types";

/**
 * The Ask Tiger brand avatar (panel header + welcome hero). Delegates to the shared sparkle mark
 * so both render the same artwork.
 */
export function AskTigerLogo({ className = "" }: AskTigerLogoProps) {
  return (
    <span className={`${s.root} ${className}`}>
      <AskTigerSparkle className={s.badge} />
    </span>
  );
}
